import { Injectable, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';
import { TimeFormat } from '@shared/models/time-format';
import { SettingsService } from '@core/services/settings/settings.service';

@Pipe({ standalone: true, name: 'dateFormat' })
@Injectable({
  providedIn: 'root' // Важно для инжекции
})
export class DateFormat implements PipeTransform {
	constructor(private settingsService: SettingsService) {}

	transform(value: string | Date, dateFormat: string, timeZone: TimeFormat): any {
		if (!value) {
			return null;
		}

		const zone =
			timeZone === TimeFormat.Z
				? 'GMT'
				: this.settingsService.user.timeZone$.getValue() || 'GMT';

		const date = moment(value).tz(zone);
		return date ? date.format(dateFormat) : null;
	}
}
